import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import NoSSR from 'react-no-ssr';
import Ad from '@ifeng-fe/ui_pc_ad';
import ChipEdit from 'ChipEdit';
import transform from '../../../common/transform';
import { QQShare, Hongbao, BrowserGuideLayer } from 'ThreeTerminal_mobile_dynamic';
import { addEventListener } from '@ifeng-fe/ui_base';
import { handleTjLink } from '@ifeng-fe/container_content/common/client/utils/utils';
import { handleFinanceAdPicClick } from '@src/utils/utils';
import styles from './index.css';
import Header from './header';
import Content from './content';
import BottomSlides from './bottomSlides';
import Affix from './affix';

class Layout extends React.PureComponent {
    static propTypes = { content: PropTypes.object };

    async componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
        this.unHandleClick = addEventListener(document, 'click', handleTjLink);
        document.addEventListener('click', handleFinanceAdPicClick, true);
    }

    componentWillUnmount() {
        this.unHandleClick();
        document.removeEventListener('click', handleFinanceAdPicClick, true);
    }

    render() {
        const {
            content: {
                channel,
                docData,
                docData: { relatedRecommend, createTime },
                comment,
                downloads,
                recommendDefault,
                fiction,
                bottomNav,
                footer,
                nav,
                hongbao,
                logoPPX,
                sharePPX,
                ppxAd,
                topAd,
                infoAd0,
                infoAd1,
                infoAd2,
                bannerAd,
                articleAd,
                recommendAd,
                unfoldType,
                keywords,
                safeLevel,
                isCloseAlgRec,
                hasCopyRight,
                articleBottomAd,
                fullScreenAd,
                hotNews,
                interact,
                recommendSearchAd,
                sourceReason,
                textListAd,
                searchAd,
                cutoffGray,
                headKeyword,
                unfold
            },
        } = this.props;

        const wxLaunch = (unfold && unfold.wxLaunch) || {};
        const wxLaunchConfig = {
            wxLaunchType: wxLaunch.wxLaunchType === '1' ? 'app' : 'weapp',
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch === '1',
        };
        const isHitBlack = safeLevel === 1;

        const contentData = {
            docData,
            comment,
            recommendDefault,
            fiction,
            bottomNav,
            footer,
            nav,
            sharePPX,
            ppxAd,
            topAd,
            infoAd0,
            infoAd1,
            infoAd2,
            bannerAd,
            articleAd,
            recommendAd,
            unfoldType: (unfoldType && unfoldType.articleUnfold) || '1',
            articleUnfoldLayer: (unfoldType && unfoldType.articleUnfoldLayer) || {},
            isHitBlack,
            relatedRecommend,
            isCloseAlgRec,
            hasCopyRight,
            articleBottomAd,
            hotNews,
            interact,
            sourceReason,
            textListAd,
            cutoffGray,
            createTime,
        };

        const qqShareCofig = {
            title: docData.title,
            img:
                (docData.thumbnails &&
                    docData.thumbnails.image &&
                    docData.thumbnails.image[0] &&
                    docData.thumbnails.image[0].url) ||
                'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: docData.summary || docData.title || '',
            cb: () => {
                console.log('分享成功');
            },
        };
        const browseConfig = (unfoldType && unfoldType.browserGuideLayer) || {};
        const callAppConfig = {
            docType: 'doc',
            pid: docData.base62Id,
            kind: 'inter_sflahuo03',
            noKindFrom: 1,
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8830',
        };
        const clickCallAppConfig = {
            method: 'get',
            value: 'turnon',
        };
        const clickContinueConfig = {
            method: 'get',
            value: 'carryon',
        };
        const headerData = {
            channel,
            downloads,
            docData,
            logoPPX,
            interact,
            searchAd,
        };

        return (
            <React.Fragment>
                <Header content={headerData} />
                <Content content={contentData} />
                {!isHitBlack && <BottomSlides content={docData} />}
                <Affix />
                <QQShare isHitBlack={isHitBlack} content={qqShareCofig} />
                {!isHitBlack && hongbao && (
                    <Chip id="50189" title="红包" type="struct" content={hongbao}>
                        <Hongbao tjKey={hongbao.articleCode} />
                    </Chip>
                )}
                {!isHitBlack && browseConfig.ifengArticle === '1' && (
                    <BrowserGuideLayer
                        browserConfig={browseConfig}
                        storeInfo={'Article'}
                        callAppConfig={callAppConfig}
                        clickCallAppConfig={clickCallAppConfig}
                        clickContinueConfig={clickContinueConfig}
                    />
                )}
                {!isHitBlack && (
                    <NoSSR>
                        <Ad content={fullScreenAd} />
                    </NoSSR>
                )}
                {!isHitBlack && (
                    <NoSSR>
                        <Ad content={recommendSearchAd} />
                    </NoSSR>
                )}
                <ChipEdit transform={transform} />
            </React.Fragment>
        );
    }
}

export default Layout;
